import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function useProjectMilestones(setMilestones, proj, setMilestonesGenerated) {
  const location = useLocation()
  const debouncedTimeout = useRef(null);
  useEffect(() => {
    clearTimeout(debouncedTimeout.current);
    debouncedTimeout.current = setTimeout(() => {
      // Вехи из уникальных результатов
      const byResultsMilestones = proj.results
        .filter((res) => res.year >= 2023 && location.search.includes('milestones=1'))
        .map((v) => ({
          name: `Достижение уникального результата «${v.title}»`,
          projResultId: v.id,
          projResultOriginId: v.originId,
          isReadonly: true,
          monthPlan: '',
          yearPlan: v.year,
        }));
      setMilestones((prevState) => (proj.milestones && proj.milestones.length > 0
        ? [
          // Предыдущее состояние вех, с обновленными названиями от результатов (на случай если редактировали название)
          ...prevState.map((milestone) => {
            const sameResultNewMilestone = byResultsMilestones.find((v) => v.projResultId === milestone.projResultId);
            return sameResultNewMilestone ? {
              ...milestone,
              name: sameResultNewMilestone.name,
              yearPlan: sameResultNewMilestone.yearPlan,
              monthPlan: sameResultNewMilestone.monthPlan,
            } : milestone;
          }),
          // Уже сохраненные вехи в проекте, которых нет в текущем состоянии
          ...proj.milestones
            .map((v) => ({ ...v, isReadonly: proj.results.some((res) => `Достижение уникального результата «${res.title}»` === v.name) }))
            .filter((value) => !prevState.some((milestone) => milestone.projResultId === value.projResultId)),
          // Новые вехи от новых резульатов
          ...byResultsMilestones.filter((milestone) =>
            !proj.milestones.some((v) => v.projResultId === milestone.projResultId)
                                && !prevState.some((v) => v.projResultId === milestone.projResultId)),
        ]
        : [
          // Предыдущее состояние вех, с обновленными названиями от результатов (на случай если редактировали название)
          ...prevState.map((milestone) => {
            const sameResultNewMilestone = byResultsMilestones.find((v) => v.projResultId === milestone.projResultId);
            return sameResultNewMilestone ? { ...milestone, name: sameResultNewMilestone.name } : milestone;
          }),
          // Новые вехи от новых результатов
          ...byResultsMilestones.filter((value) => !prevState.some((milestone) => milestone.projResultId === value.projResultId))]));
      setMilestonesGenerated(true);
    }, 1500);
  }, [proj]);
}
